export const SUPPLIERS_UI_STYLES = `
  .spx-shell {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    height: 100%;
    min-width: 0;
    padding: 24px;
    color: rgba(237, 243, 255, 0.95);
    background:
      radial-gradient(640px 280px at 8% 0%, rgba(34, 211, 238, 0.12), transparent 72%),
      radial-gradient(620px 260px at 94% 2%, rgba(52, 211, 153, 0.1), transparent 70%),
      linear-gradient(180deg, #07101f 0%, #0a1221 40%, #0b1422 100%);
  }

  .spx-page {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
  }

  .spx-card {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.96), rgba(7, 13, 25, 0.96)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(52, 211, 153, 0.08)) border-box;
    box-shadow: 0 24px 72px rgba(2, 8, 20, 0.3);
    overflow: hidden;
  }

  .spx-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 22px 22px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .spx-headMain {
    flex: 1 1 auto;
    min-width: 0;
  }

  .spx-kicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    color: rgba(135, 230, 255, 0.84);
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.18em;
  }

  .spx-title {
    margin: 0;
    font-size: clamp(1.35rem, 2.2vw, 2rem);
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(244, 248, 255, 0.98);
  }

  .spx-subtitle {
    margin: 10px 0 0;
    max-width: 780px;
    color: rgba(205, 219, 242, 0.72);
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .spx-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    max-width: 560px;
  }

  .spx-toolbar {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(720px 220px at 10% 0%, rgba(34, 211, 238, 0.06), transparent 72%),
      rgba(255, 255, 255, 0.02);
  }

  .spx-toolbarTop {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
    align-items: center;
  }

  .spx-search,
  .spx-input,
  .spx-select,
  .spx-textarea {
    width: 100%;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(240, 245, 255, 0.92);
    padding: 11px 13px;
    outline: none;
    box-shadow: none;
  }

  .spx-search::placeholder,
  .spx-input::placeholder,
  .spx-textarea::placeholder {
    color: rgba(240, 245, 255, 0.46);
  }

  .spx-search:focus,
  .spx-input:focus,
  .spx-select:focus,
  .spx-textarea:focus {
    border-color: rgba(48, 216, 255, 0.6);
    box-shadow: 0 0 0 3px rgba(48, 216, 255, 0.15);
  }

  .spx-select option {
    color: #08101d;
    background: #ffffff;
  }

  .spx-toolbarBottom {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .spx-chipRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .spx-chip,
  .spx-btn,
  .spx-inlineBtn,
  .spx-closeBtn {
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(217, 229, 247, 0.82);
    padding: 8px 13px;
    font-size: 0.77rem;
    font-weight: 800;
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .spx-chip:hover,
  .spx-btn:hover,
  .spx-inlineBtn:hover,
  .spx-closeBtn:hover {
    transform: translateY(-1px);
  }

  .spx-chip--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.16);
    color: rgba(214, 251, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(34, 211, 238, 0.09);
  }

  .spx-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .spx-inlineBtn {
    padding: 6px 11px;
    font-size: 0.72rem;
  }

  .spx-btn--primary {
    border-color: rgba(34, 211, 238, 0.55);
    background: linear-gradient(135deg, rgba(34, 211, 238, 0.95), rgba(59, 130, 246, 0.88));
    color: #07131e;
  }

  .spx-btn--success {
    border-color: rgba(52, 211, 153, 0.5);
    background: linear-gradient(135deg, rgba(52, 211, 153, 0.95), rgba(16, 185, 129, 0.88));
    color: #07160f;
  }

  .spx-btn--warning {
    border-color: rgba(251, 191, 36, 0.48);
    background: linear-gradient(135deg, rgba(251, 191, 36, 0.94), rgba(249, 115, 22, 0.88));
    color: #171005;
  }

  .spx-btn--ghost {
    background: transparent;
  }

  .spx-btn:disabled,
  .spx-chip:disabled,
  .spx-closeBtn:disabled,
  .spx-inlineBtn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  .spx-note {
    color: rgba(204, 217, 241, 0.7);
    font-size: 0.79rem;
    line-height: 1.5;
  }

  .spx-banner {
    margin: 0 20px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 10px 12px;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .spx-banner--success {
    border-color: rgba(52, 211, 153, 0.36);
    background: rgba(52, 211, 153, 0.12);
    color: rgba(187, 248, 220, 0.98);
  }

  .spx-banner--error {
    border-color: rgba(248, 113, 113, 0.36);
    background: rgba(248, 113, 113, 0.12);
    color: rgba(255, 210, 210, 0.98);
  }

  .spx-banner--info {
    border-color: rgba(34, 211, 238, 0.34);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(205, 247, 255, 0.98);
  }

  .spx-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    padding: 14px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
  }

  .spx-stat {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.025);
    min-width: 0;
  }

  .spx-statLabel {
    color: rgba(218, 229, 247, 0.63);
    font-size: 0.71rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .spx-statValue {
    color: rgba(238, 244, 255, 0.95);
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.1;
  }

  .spx-tableWrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .spx-table {
    width: 100%;
    min-width: 1500px;
    border-collapse: separate;
    border-spacing: 0;
  }

  .spx-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    text-align: left;
    padding: 12px;
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.45px;
    font-weight: 800;
    color: rgba(214, 227, 247, 0.8);
    background: linear-gradient(180deg, rgba(25, 31, 53, 0.95), rgba(14, 18, 34, 0.95));
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
  }

  .spx-table tbody tr {
    background: rgba(255, 255, 255, 0.018);
    transition: background 120ms ease, box-shadow 120ms ease, transform 120ms ease;
  }

  .spx-table tbody tr:nth-child(even) {
    background: rgba(255, 255, 255, 0.012);
  }

  .spx-table tbody tr:hover {
    background: rgba(48, 216, 255, 0.055);
    transform: translateY(-1px);
    box-shadow: 0 16px 44px rgba(0, 0, 0, 0.22);
  }

  .spx-table tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    color: rgba(234, 241, 252, 0.87);
    font-size: 0.83rem;
    vertical-align: middle;
  }

  .spx-code {
    color: rgba(126, 229, 255, 0.94);
    font-size: 0.74rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .spx-strong {
    color: rgba(244, 248, 255, 0.96);
    font-weight: 800;
  }

  .spx-muted {
    color: rgba(210, 222, 242, 0.74);
  }

  .spx-linkBtn {
    border: 0;
    background: transparent;
    padding: 0;
    color: rgba(126, 229, 255, 0.94);
    font-weight: 800;
    cursor: pointer;
    text-align: left;
  }

  .spx-linkBtn:disabled {
    cursor: default;
    opacity: 0.95;
  }

  .spx-linkBtn:hover:not(:disabled) {
    color: rgba(190, 244, 255, 0.98);
  }

  .spx-status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 92px;
    padding: 5px 10px;
    border-radius: 999px;
    border: 1px solid transparent;
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .spx-status--active {
    background: rgba(46, 204, 113, 0.13);
    color: rgba(188, 248, 214, 0.96);
    border-color: rgba(46, 204, 113, 0.44);
  }

  .spx-status--inactive {
    background: rgba(248, 113, 113, 0.12);
    color: rgba(255, 209, 209, 0.96);
    border-color: rgba(248, 113, 113, 0.4);
  }

  .spx-empty {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    text-align: center;
    color: rgba(204, 217, 241, 0.68);
    font-size: 0.94rem;
  }

  .spx-mobileList {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
    overflow: auto;
    padding: 14px;
  }

  .spx-mobileCard {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.03);
    padding: 12px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.26);
  }

  .spx-mobileTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
  }

  .spx-mobileRows {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 10px;
    margin-top: 10px;
  }

  .spx-mobileLabel {
    font-size: 0.67rem;
    color: rgba(206, 219, 243, 0.58);
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 2px;
    font-weight: 700;
  }

  .spx-mobileValue {
    font-size: 0.82rem;
    color: rgba(232, 239, 251, 0.9);
    overflow-wrap: anywhere;
  }

  .spx-mobileActions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
  }

  .spx-modalBackdrop {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(3, 8, 18, 0.72);
    backdrop-filter: blur(12px);
  }

  .spx-modal {
    width: min(760px, calc(100vw - 32px));
    max-height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.99), rgba(7, 13, 25, 0.99)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(52, 211, 153, 0.08)) border-box;
    box-shadow: 0 36px 96px rgba(0, 0, 0, 0.46);
    overflow: hidden;
    color: rgba(237, 243, 255, 0.95);
  }

  .spx-modal--wide {
    width: min(1120px, calc(100vw - 32px));
  }

  .spx-modalHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 22px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background:
      radial-gradient(480px 180px at 0% 0%, rgba(34, 211, 238, 0.1), transparent 70%),
      rgba(255, 255, 255, 0.02);
  }

  .spx-modalKicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    color: rgba(135, 230, 255, 0.84);
    font-size: 0.69rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.18em;
  }

  .spx-modalTitle {
    margin: 0;
    font-size: 1.24rem;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(244, 248, 255, 0.98);
  }

  .spx-modalSubtitle {
    margin: 8px 0 0;
    color: rgba(205, 219, 242, 0.72);
    font-size: 0.85rem;
    line-height: 1.5;
    max-width: 720px;
  }

  .spx-closeBtn {
    min-width: 40px;
    height: 40px;
    padding: 0;
    font-size: 1rem;
    line-height: 1;
  }

  .spx-modalBody {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 16px;
    min-height: 0;
    overflow: auto;
    padding: 18px 22px;
  }

  .spx-formGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .spx-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .spx-field--full {
    grid-column: 1 / -1;
  }

  .spx-label {
    color: rgba(218, 229, 247, 0.7);
    font-size: 0.71rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
  }

  .spx-textarea {
    min-height: 96px;
    resize: vertical;
  }

  .spx-help {
    color: rgba(204, 217, 241, 0.62);
    font-size: 0.74rem;
    line-height: 1.45;
  }

  .spx-switchRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.025);
  }

  .spx-switchMeta {
    min-width: 0;
  }

  .spx-switchTitle {
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.84rem;
    font-weight: 800;
  }

  .spx-switchCopy {
    margin-top: 3px;
    color: rgba(205, 219, 242, 0.68);
    font-size: 0.76rem;
    line-height: 1.45;
  }

  .spx-switchInput {
    width: 18px;
    height: 18px;
    accent-color: rgba(34, 211, 238, 0.88);
    flex: 0 0 auto;
  }

  .spx-alert {
    border-radius: 14px;
    border: 1px solid rgba(248, 113, 113, 0.36);
    background: rgba(248, 113, 113, 0.12);
    color: rgba(255, 210, 210, 0.98);
    padding: 10px 12px;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .spx-modalFooter {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 2px;
  }

  .spx-previewMeta {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
  }

  .spx-previewWrap {
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.025);
    overflow: auto;
    max-height: min(52vh, 520px);
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .spx-previewTable {
    width: 100%;
    min-width: 840px;
    border-collapse: separate;
    border-spacing: 0;
  }

  .spx-previewTable thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 11px 12px;
    text-align: left;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.45px;
    font-weight: 800;
    color: rgba(214, 227, 247, 0.82);
    background: linear-gradient(180deg, rgba(25, 31, 53, 0.98), rgba(14, 18, 34, 0.98));
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
  }

  .spx-previewTable tbody td {
    padding: 10px 12px;
    font-size: 0.82rem;
    color: rgba(232, 239, 251, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    vertical-align: top;
  }

  .spx-previewTable tbody tr:nth-child(even) {
    background: rgba(255, 255, 255, 0.015);
  }

  @media (max-width: 920px) {
    .spx-head,
    .spx-toolbarTop {
      grid-template-columns: 1fr;
      flex-direction: column;
      align-items: stretch;
    }

    .spx-head {
      flex-direction: column;
    }

    .spx-actions {
      justify-content: flex-start;
      max-width: none;
    }

    .spx-toolbarBottom {
      flex-direction: column;
      align-items: stretch;
    }

    .spx-formGrid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    .spx-shell {
      padding: 12px;
    }

    .spx-card,
    .spx-modal {
      border-radius: 18px;
    }

    .spx-head,
    .spx-toolbar,
    .spx-modalHeader,
    .spx-modalBody {
      padding-left: 14px;
      padding-right: 14px;
    }

    .spx-stats {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      padding: 10px 12px;
    }

    .spx-mobileRows {
      gap: 6px 8px;
    }
  }

  @media (max-height: 820px) {
    .spx-shell { zoom: 0.9; height: calc((100dvh - 28px) / 0.9); }
  }

  @media (max-height: 720px) {
    .spx-shell { zoom: 0.8; height: calc((100dvh - 28px) / 0.8); }
  }

  @media (max-height: 620px) {
    .spx-shell { zoom: 0.7; height: calc((100dvh - 28px) / 0.7); }
  }
`;

const IMPORT_FIELD_ALIASES = {
  supplier_id: ["supplier_id", "supplier_code", "supplierid", "code", "id"],
  name: ["name", "supplier_name", "supplier", "vendor", "vendor_name"],
  contact_name: ["contact_name", "contact", "contact_person", "contact_person_name", "contactperson"],
  email: ["email", "emails", "mail"],
  phone: ["phone", "phone_number", "telephone", "mobile", "tel"],
  address: ["address", "location", "street"],
  tax_id: ["tax_id", "taxid", "tax", "vat", "vat_number", "nif", "cif"],
  minimum_order_amount: ["minimum_order_amount", "minimum_order"],
  is_active: ["is_active", "active", "status", "enabled"],
  is_stock_supplier: ["is_stock_supplier", "stock_supplier", "stock", "materials"],
  is_service_supplier: ["is_service_supplier", "service_supplier", "services"],
};

function supplierImportUsageFlag(value, fallback) {
  const text = String(value ?? "").trim().toLowerCase();
  if (!text) return fallback;
  if (["true", "1", "yes", "y", "si", "sí"].includes(text)) return true;
  if (["false", "0", "no", "n"].includes(text)) return false;
  throw new Error("Supplier usage must be true or false.");
}

function normalizeImportKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function coerceImportBoolean(value) {
  if (typeof value === "boolean") return value;
  const text = String(value ?? "")
    .trim()
    .toLowerCase();

  if (!text) return true;
  if (["false", "0", "inactive", "disabled", "no", "n"].includes(text)) return false;
  return true;
}

export function supplierEmailsToText(value) {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join("; ");
  }
  return String(value || "").trim();
}

export function truncateSupplierText(value, maxLength = 52) {
  const text = String(value || "-");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function formatSupplierDate(value) {
  if (!value) return "-";
  try {
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(value));
  } catch (error) {
    return "-";
  }
}

export function getSupplierStatusMeta(isActive) {
  return isActive
    ? { label: "Active", className: "spx-status spx-status--active" }
    : { label: "Inactive", className: "spx-status spx-status--inactive" };
}

export function sortSuppliersList(rows) {
  return [...rows].sort((left, right) => {
    const activeDelta = Number(Boolean(right?.is_active)) - Number(Boolean(left?.is_active));
    if (activeDelta !== 0) return activeDelta;
    return String(left?.name || "").localeCompare(String(right?.name || ""), undefined, {
      sensitivity: "base",
    });
  });
}

export function normalizeSupplierImportRows(rows) {
  return (rows || [])
    .map((row) => {
      const keyedEntries = Object.entries(row || {}).map(([key, value]) => [normalizeImportKey(key), value]);
      const keyed = Object.fromEntries(keyedEntries);
      const pickValue = (field) => {
        for (const alias of IMPORT_FIELD_ALIASES[field]) {
          if (keyed[alias] === undefined || keyed[alias] === null) continue;
          const textValue = String(keyed[alias]).trim();
          if (textValue !== "") return keyed[alias];
        }
        return "";
      };

      return {
        supplier_id: String(pickValue("supplier_id") || "").trim(),
        name: String(pickValue("name") || "").trim(),
        contact_name: String(pickValue("contact_name") || "").trim(),
        email: String(pickValue("email") || "").trim(),
        phone: String(pickValue("phone") || "").trim(),
        address: String(pickValue("address") || "").trim(),
        tax_id: String(pickValue("tax_id") || "").trim(),
        minimum_order_amount: pickValue("minimum_order_amount"),
        is_active: coerceImportBoolean(pickValue("is_active")),
        is_stock_supplier: supplierImportUsageFlag(pickValue("is_stock_supplier"), true),
        is_service_supplier: supplierImportUsageFlag(pickValue("is_service_supplier"), false),
      };
    })
    .filter((row) =>
      Object.entries(row).some(([key, value]) => {
        if (key === "is_stock_supplier" || key === "is_service_supplier") return false;
        if (typeof value === "boolean") return value !== true;
        return String(value || "").trim() !== "";
      })
    );
}

export const SUPPLIER_IMPORT_COLUMNS = [
  "supplier_id",
  "name",
  "contact_name",
  "email",
  "phone",
  "address",
  "tax_id",
  "minimum_order_amount",
  "is_active",
  "is_stock_supplier",
  "is_service_supplier",
];
